import { MAX_CONTENT_WIDTH_PX, spacingVars } from '@tundr/ds-foundations';
import { themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const containerClass = style({
  display: 'flex',
  width: '100%',
  height: '100%',
});

export const contentBackgroundClass = style({
  backgroundColor: themeVars.colors.neutrals.brown2,
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  position: 'relative',
});

/** Full-width inset (padding); max width applies only to the inner main column. */
export const contentInsetClass = style({
  width: '100%',
  padding: spacingVars['3xl'],
});

/** Main column: up to 1440px content width, excluding outer inset padding. */
export const contentMainClass = style({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: MAX_CONTENT_WIDTH_PX,
  margin: '0 auto',
});

export const contentWithNotificationClass = style({
  paddingTop: 100,
});

export const contentClass = style({
  width: '100%',
});

export const headerWrapperClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});
